module.exports = __webpack_public_path__ + "img/Spielen.88a2d161.jpg";